import { ProductOption } from "./ProductOption";

export class Option {
    optionId;
    optionName;
    productOptions;

    constructor(jsonData) {
        Object.assign(this, jsonData);
        this.productOptions = [];
        for (let o of jsonData.productOptions) {
            o.productOptionOverlay = o.productOptionOverlay.replace('~', '').toLowerCase();
            this.productOptions.push(new ProductOption(o));
        }
    }

    showProductOptionsCount() {
        alert(this.productOptions.length);
    }
}
